import styled from 'styled-components';
import { Button } from 'antd';

import { ArrowRightIcon } from '@/assets/icons/v2';

export const HAIRLINE_COLOR = '#E6E8E8';
export const ACTION_ICON_SIZE = '1.5rem';

interface ActionButtonProps {
	$tone: string;
}

export const Hairline = styled.hr`
	width: 100%;
	margin: 0;
	border: none;
	border-top: 1px solid ${HAIRLINE_COLOR};
`;

export const BlockTitle = styled.h3`
	margin: 0;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1.5rem;
	font-weight: 600;
	line-height: 1.375rem;
`;

export const ActionButton = styled(Button)<ActionButtonProps>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 0.25rem;
	height: 2.5rem;
	padding: 0.5rem;
	background: ${({ theme }) => theme.palette.secondary.white};
	border: 1px solid ${({ $tone }) => $tone};
	border-radius: 0.25rem;
	box-shadow: none;
	color: ${({ $tone }) => $tone};
	font-size: 1rem;
	line-height: 1.5rem;
	letter-spacing: -0.005rem;

	&:hover,
	&:focus {
		background: ${({ theme }) => theme.palette.secondary.white};
		border-color: ${({ $tone }) => $tone};
		color: ${({ $tone }) => $tone};
	}

	svg {
		width: ${ACTION_ICON_SIZE};
		height: ${ACTION_ICON_SIZE};
	}
`;

export const NavButton = styled(Button)`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 2.5rem;
	height: 2.5rem;
	padding: 0.5rem;
	background: ${({ theme }) => theme.palette.secondary.white};
	border: 1px solid ${({ theme }) => theme.palette.secondary[150]};
	border-radius: 0.25rem;
	box-shadow: none;
	color: ${({ theme }) => theme.palette.secondary[400]};

	&:hover,
	&:focus {
		background: ${({ theme }) => theme.palette.secondary.white};
		border-color: ${({ theme }) => theme.palette.primary[600]};
		color: ${({ theme }) => theme.palette.primary[600]};
	}

	svg {
		width: ${ACTION_ICON_SIZE};
		height: ${ACTION_ICON_SIZE};
	}
`;

export const BackArrow = styled(ArrowRightIcon)`
	display: block;
	transform: rotate(180deg);
`;

export const VideoBox = styled.div`
	overflow: hidden;
	background: ${({ theme }) => theme.palette.secondary.white};
	border-radius: 1rem;
`;

export const Content = styled.div`
	padding: 2.5rem;
	background: ${({ theme }) => theme.palette.secondary.white};
	border-radius: 1rem;
`;

export const FieldLabel = styled.span`
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1rem;
	font-weight: 600;
	line-height: 1.5rem;
`;
